var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1V8H8.5V1H7.5Z",
    fill: "#00A92F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.81244C3 6.93059 4.03942 5.29082 5.57785 4.43714L5.09264 3.56274C3.24937 4.58557 2 6.55276 2 8.81244C2 12.1262 4.68629 14.8124 8 14.8124C11.3137 14.8124 14 12.1262 14 8.81244C14 6.59097 12.7925 4.65212 11.0004 3.61544L10.4996 4.48105C11.9954 5.34633 13 6.96237 13 8.81244C13 11.5739 10.7614 13.8124 8 13.8124C5.23858 13.8124 3 11.5739 3 8.81244Z",
    fill: "#00A92F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.d0a37c1cb63d291d9745e9f2a848b281.svg";
export { ForwardRef as ReactComponent };